let activeSelect99 = null;

class Select99 extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.trigger = this.querySelector('.select-99__trigger');
    this.valueEl = this.querySelector('[data-select-value]');
    this.flagEl = this.querySelector('[data-select-flag]');
    this.optionsList = this.querySelector('.select-99__options');
    this.searchInput = this.querySelector('.select-99__search');
    this.options = Array.from(this.querySelectorAll('.select-99__option'));
    this.hiddenInput = this.querySelector('input[type="hidden"]');

    this.trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      this.toggle();
    });

    this.options.forEach((option) => {
      option.addEventListener('click', () => {
        if (option.hidden) return;
        this.selectOption(option);
      });
    });

    if (this.searchInput) {
      this.searchInput.addEventListener('click', (event) => event.stopPropagation());
      this.searchInput.addEventListener('input', () => this.filterOptions());
    }

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.close();
    });

    this.initialized = true;
  }

  get value() {
    return this.hiddenInput.value;
  }

  set value(val) {
    const option = this.options.find((option) => option.dataset.value === val);
    if (option) this.selectOption(option, false);
  }

  toggle() {
    this.optionsList.hidden ? this.open() : this.close();
  }

  open() {
    if (activeSelect99 && activeSelect99 !== this) {
      activeSelect99.close();
    }

    this.optionsList.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
    activeSelect99 = this;

    if (this.searchInput) {
      this.searchInput.value = '';
      this.filterOptions();
      this.searchInput.focus();
    }
  }

  close() {
    this.optionsList.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');

    if (activeSelect99 === this) {
      activeSelect99 = null;
    }
  }

  filterOptions() {
    const query = this.searchInput.value.trim().toLowerCase();
    this.options.forEach((option) => {
      const matches = option.textContent.toLowerCase().includes(query);
      option.style.display = matches ? '' : 'none';
    });
  }

  selectOption(option, dispatch = true) {
    this.options.forEach((option) => option.classList.remove('is-selected'));
    option.classList.add('is-selected');

    const textPart = option.querySelector('.select-99__option-text');
    this.valueEl.innerHTML = textPart ? textPart.innerHTML : option.innerHTML;

    this.hiddenInput.value = option.dataset.value;

    if (this.flagEl && option.dataset.flag) {
      this.flagEl.src = option.dataset.flag;
    }

    this.close();

    if (dispatch) {
      this.dispatchEvent(new CustomEvent('change', { detail: { value: option.dataset.value }, bubbles: true }));
    }
  }

  setOptionVisibility(value, visible) {
    const option = this.options.find((option) => option.dataset.value === value);
    if (!option) return;

    option.hidden = !visible;

    if (!visible && option.classList.contains('is-selected')) {
      const fallback = this.options.find((option) => !option.hidden);
      if (fallback) this.selectOption(fallback, false);
    }
  }
}

customElements.define('select-99', Select99);

class Localization99 extends HTMLElement {
  connectedCallback() {
    if (!this.initialized) {
      this.toggleButton = this.querySelector('.header-99__flag-toggle');
      this.panel = this.querySelector('.localization-99__panel');
      this.overlay = this.querySelector('.localization-99__overlay');
      this.closeButton = this.querySelector('.localization-99__close');
      this.countrySelect = this.querySelector('select-99[data-role="country"]');
      this.languageSelect = this.querySelector('select-99[data-role="language"]');

      this.toggleButton.addEventListener('click', this.togglePanel.bind(this));
      this.closeButton.addEventListener('click', this.closePanel.bind(this));
      this.overlay.addEventListener('click', this.closePanel.bind(this));
      this.countrySelect.addEventListener('change', this.onCountryChange.bind(this));

      this.mobileParent = this.parentElement;
      this.desktopSlot = document.getElementById('LocalizationSlotDesktop99');
      this.desktopQuery = window.matchMedia('(min-width: 769px)');
      this.desktopQuery.addEventListener('change', () => this.placeForViewport());

      this.initialized = true;
    }

    this.placeForViewport();
  }

  placeForViewport() {
    if (!this.desktopSlot || !this.mobileParent) return;
    const target = this.desktopQuery.matches ? this.desktopSlot : this.mobileParent;
    if (this.parentElement !== target) {
      target.appendChild(this);
    }
  }

  togglePanel() {
    const isOpen = !this.panel.hidden;
    isOpen ? this.closePanel() : this.openPanel();
  }

  openPanel() {
    this.panel.hidden = false;
    this.overlay.classList.add('is-open');
    this.toggleButton.setAttribute('aria-expanded', 'true');
  }

  closePanel() {
    this.panel.hidden = true;
    this.overlay.classList.remove('is-open');
    this.toggleButton.setAttribute('aria-expanded', 'false');
  }

  onCountryChange(event) {
    if (!this.languageSelect) return;

    const selectedOption = this.countrySelect.querySelector(
      `.select-99__option[data-value="${event.detail.value}"]`
    );
    const hasGerman = selectedOption?.dataset.hasGerman === 'true';

    this.languageSelect.setOptionVisibility('de', hasGerman);
  }
}

customElements.define('localization-99', Localization99);